import { fetchBlocksRequest } from "actions";
import { BBABalance, BlockNumber } from "components/blockchain";
import { BlockHash } from "components/common/BlockHash";
import Pagination from "components/datatable/pagination";
import Table from "components/datatable/table";
import { BlockInterface } from "interfaces/block.interface";
import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers";
import { AppDispatch } from "store";
import { formatNumber } from "utils";

const Blocks = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { blocks } = useSelector((state: RootState) => state.blocks);

  useEffect(() => {
    dispatch(fetchBlocksRequest(blocks.meta.page, blocks.meta.take));
  }, [dispatch, blocks.meta.page, blocks.meta.take]);

  // Define the columns with optional "render" for custom display
  const columns = [
    {
      title: "Block Height",
      render: (value: any, block: BlockInterface) => (
        <BlockNumber height={block.block_number} link />
      ),
    },
    {
      title: "Block Hash",
      render: (value: any, block: BlockInterface) => (
        <div className="flex max-w-[160px] gap-[1px]">
          <BlockHash
            hash={block.block_hash}
            height={block.block_number}
            truncate={16}
            link
          />
        </div>
      ),
    },
    {
      title: "Reward",
      render: (value: any, block: BlockInterface) => (
        <BBABalance
          daltons={block.rewards.reduce(
            (acc: any, item: any) => acc + item.daltons,
            0
          )}
        />
      ),
    },
    {
      title: "Txs Count",
      render: (value: any, block: BlockInterface) => (
        <p className="text-small">
          {formatNumber(block.transactions?.length || 0, 0)}
        </p>
      ),
    },
    {
      title: "Block Time",
      render: (value: any, block: BlockInterface) => (
        <p className="text-small">{moment.unix(block.block_time).fromNow()}</p>
      ),
    },
  ];

  return (
    <>
      <>
        <div className="mb-12 mt-10 px-2.5 md:px-3 lg:px-5">
          <div className="box overflow-hidden bg-white dark:bg-darkPrimary">
            <div className="mt-5 flex flex-col">
              <div className="flex w-full flex-row flex-wrap items-center justify-between gap-1 px-2.5 py-5 md:px-5">
                <div className="text-large not-italic">
                  More than {formatNumber(blocks.meta.itemCount, 0)} blocks
                  found
                </div>
              </div>
            </div>

            {/* Replaced the inline table with our new Table component */}
            <Table
              columns={columns}
              data={blocks.data}
              tableClassName="table w-full"
            />

            <Pagination
              page={blocks.meta.page}
              totalPage={blocks.meta.pageCount}
              hasPrevPage={blocks.meta.hasPreviousPage}
              hasNextPage={blocks.meta.hasNextPage}
              onPageChange={(page) => {
                dispatch(fetchBlocksRequest(page, blocks.meta.take));
              }}
              onTakeChange={(take) => {
                dispatch(fetchBlocksRequest(1, take));
              }}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default Blocks;
